module.exports = __webpack_public_path__ + "static/media/background1.f14d0043.png";